module.exports = __webpack_public_path__ + "static/media/float_1688.7896070c.png";